import { render, staticRenderFns } from "./CustomCardStyles.vue?vue&type=template&id=9f864c5e&scoped=true"
import script from "./CustomCardStyles.vue?vue&type=script&lang=ts"
export * from "./CustomCardStyles.vue?vue&type=script&lang=ts"
import style0 from "./CustomCardStyles.vue?vue&type=style&index=0&id=9f864c5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f864c5e",
  null
  
)

export default component.exports